import { render, staticRenderFns } from "./ScoreTab.vue?vue&type=template&id=492fb496&"
import script from "./ScoreTab.vue?vue&type=script&lang=js&"
export * from "./ScoreTab.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports